import { memo } from "react";

import type { QueryData } from "../../../model";

type Props = {
	bookedGuestSurvey: NonNullable<QueryData["bookedGuestSurvey"]>;
};

/**
 * 予約後アンケート（予約完了画面）のゲスト回答を Q&A 形式で表示する。
 */
export const ListOfBookedGuestSurveyCompositions = memo(({ bookedGuestSurvey }: Props) => {
	return (
		<div className="space-y-5">
			{bookedGuestSurvey.answers.map(({ question, answer }, index) => (
				<div key={index} className="whitespace-pre-wrap text-xs sm:text-sm lg:text-sm">
					<p className="mb-2">{`Q. ${question}`}</p>
					<p>{`A. ${answer}`}</p>
				</div>
			))}
		</div>
	);
});

ListOfBookedGuestSurveyCompositions.displayName = "ListOfBookedGuestSurveyCompositions";
